import { render, staticRenderFns } from "./joinItem.vue?vue&type=template&id=f045e390&scoped=true&"
import script from "./joinItem.vue?vue&type=script&lang=js&"
export * from "./joinItem.vue?vue&type=script&lang=js&"
import style0 from "./joinItem.vue?vue&type=style&index=0&id=f045e390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f045e390",
  null
  
)

export default component.exports